import script from "./CustomDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./CustomDropdown.vue?vue&type=style&index=0&id=6827e3bb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6827e3bb"]])

export default __exports__